<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <h5 v-if="formType == 'edit'" class="form-header">
              Editar {{ '' }} {{ oldName }}
            </h5>
            <h5 v-else class="form-header">Adicionar {{ '' }}</h5>
          </div>
          <div class="col-xs-12 pl-3 pr-3">
            <b-form-text id="nameInput">Nome *</b-form-text>
            <b-form-input
              v-model="form.NAME"
              placeholder="Informe o nome"
              maxlength="24"
              size="sm"
              :formatter="notEmpty"
              aria-describedby="nameInput nameInputLiveFeedback"
              id="nameInput"
              :state="nameState && notRepeatedName"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>

            <b-form-text id="dilutionInput">Diluição *</b-form-text>
            <b-form-input
              v-model="form.DILUTION"
              placeholder="Informe a diluição"
              maxlength="24"
              size="sm"
              type="number"
              :formatter="notEmpty"
              aria-describedby="dilutionInput dilutionInputLiveFeedback"
              id="dilutionInput"
              :state="dilutionInputState"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!dilutionInputState"
              id="dilutionInputStateLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>

            <b-form-text id="compositionInput">Composição *</b-form-text>
            <b-form-input
              v-model="form.COMPOSITION"
              placeholder="Informe a composição"
              maxlength="24"
              size="sm"
              :formatter="notEmpty"
              aria-describedby="compositionInput compositionInputLiveFeedback"
              id="compositionInput"
              :state="compositionInputState"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!compositionInputState"
              id="compositionInputLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>

            <b-form-checkbox
              v-model="form.isEspecial"
              size="sm"
              name="isEspecial"
              id="isEspecialInput"
            >
              É especial?  *
            </b-form-checkbox>

            <b-form-text id="noteInput">Anotação *</b-form-text>
            <b-form-input
              v-model="form.NOTE"
              placeholder=""
              maxlength="24"
              size="sm"
              :formatter="notEmpty"
              aria-describedby="noteInput wiltPointInputLiveFeedback"
              id="noteInput"
            >
            </b-form-input>
          </div>
        </b-form>
      </div>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2">
        <b-btn size="sm" variant="outline-secondary" @click="$emit('close-form')" class="ml-2 mr-1"> Fechar </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1 mr-2"> Salvar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  testName,
  notEmpty,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
export default {
  name: "actuator-form",
  props: {
    showForm: Boolean,
    formType: String,
    itemToEdit: [Number, Object],
    oldName: String,
    alreadyUsedNames: [Number, Array],
  },
  data() {
    return {
      errors: [],
      form: {
        NAME:'',
        DILUTION :'',
        COMPOSITION:'',
        isEspecial:false,
        NOTE:''
      },
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.form.ID = this.itemToEdit.ID;
          this.form.NAME = this.itemToEdit.NAME;
          this.form.DILUTION  = this.itemToEdit.DILUTION ;
          this.form.COMPOSITION = this.itemToEdit.COMPOSITION;
          this.form.isEspecial = this.itemToEdit.isEspecial;
          this.form.NOTE = this.itemToEdit.NOTE;
        }
      }
    },
  },
  computed: {
    nameState() {
      return testName(this.form.NAME);
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
      // return true
    },
    dilutionInputState(){
      return false
    },
    compositionInputState(){
      return false
    },
    isEspecialInputState(){
      return false
    },
  },
  methods: {
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.form = {
        name:'',
        DILUTION :'',
        COMPOSITION:'',
        isEspecial:false,
        NOTE:''
      };
    },
    checkForm() {
      this.errors = [];
      this.$emit('submit',this.form)
      this.$emit("close-form");
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .container-form{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0;
    margin-right: 0;
  }
  #form, #details {
    padding-top: 1em;
    /* padding-top: 80px; */
}
}
</style>
